<template>
  <div :class="['tva-slider']">
    <div class="tva-slider-container" ref="slider">
      <slot></slot>
    </div>

    <div :class="['tva-arrows', { graph }]">
      <RoundIconButton
        v-for="(arrowDirection, i) of ['sx', 'dx']"
        :key="arrowDirection"
        :class="['tva-arrow', 'tva-arrow-' + arrowDirection, { graph }]"
        :icon="arrowDownSmall"
        :ariaLabel="arrowAriaLabels[i]"
        :black="!white"
        :white="white"
        :graph="graph"
        @onClick="manageClick(arrowDirection)"
      />
    </div>
  </div>
</template>

<script>
import Flickity from "flickity-imagesloaded";
import { arrowDownSmall } from "@/assets/icons/icons.js";

import RoundIconButton from "./RoundIconButton.vue";

export default {
  components: {
    RoundIconButton,
  },
  props: {
    config: {
      type: Object,
      default: null,
    },
    white: Boolean,
    graph: Boolean,
  },
  data() {
    return {
      arrowDownSmall,
      isFlickity: false,
      elementsCount: [],
      index: 0,
      arrowAriaLabels: ["To previous", "To next"],
      fade: false,
      options: {
        draggable: ">1",
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        lazyLoad: true,
        adaptiveHeight: true,
        fade: false,
        contain: true,
        cellAlign: "left",
      },
    };
  },
  created() {
    this.setProps(this.config);
  },
  watch: {
    config(config) {
      this.setProps(config);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.elementsCount = new Array(this.$refs.slider.childElementCount).fill(
        0
      );
      this.createFlickity();

      window.addEventListener("resize", () => {
        this.createFlickity();
      });
    });
  },
  methods: {
    setProps(config) {
      if (config) {
        for (const [key, value] of Object.entries(config)) {
          this[key] = value;
        }
      }
    },
    createFlickity() {
      const elem = this.$refs.slider;

      if (elem && !this.isFlickity) {
        this.flkty = new Flickity(elem, this.options);

        this.flkty.on("change", (index) => {
          this.index = index;
          this.$emit("change", index);
        });

        this.flkty.on(
          "dragStart",
          () => (this.flkty.slider.style.pointerEvents = "none")
        );
        this.flkty.on(
          "dragEnd",
          () => (this.flkty.slider.style.pointerEvents = "auto")
        );

        this.isFlickity = true;
      } else if (!elem && this.isFlickity) {
        this.flkty.destroy();
        this.flkty = null;
        this.isFlickity = false;
      }
    },
    manageClick(arrowDirection) {
      arrowDirection === "sx" ? this.goPrevious() : this.goNext();
    },
    goPrevious() {
      this.flkty.previous();
    },
    goNext() {
      this.flkty.next();
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  height: 100%;
}

.tva-slider-container {
  width: 100%;
}
.tva-slider {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .desktop &,
  .large &,
  .tablet & {
    // &::after, &::before {
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   left: 100%;
    //   fill: rgba(0, 0, 0, 0.25);
    //   backdrop-filter: blur(5px);
    //   width: calc(50vw - 50%);
    //   height: calc(100% );
   
    // }
    // &::before {
    //   left: auto;
    //   right: 100%;
    //   z-index: 1;
    // }
  }

  .tva-arrows {
    z-index: 1;
    color: var(--brand-weaker);

    .mobile & {
      right: initial;
      left: 0;
    }

    &.graph {
      top: unset;
      right: unset;
      bottom: 0;
      left: 0;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateX(toRem(-30));
        width: var(--vw-no-scrollbar, 100vw);
        height: 1px;
        z-index: -1;
        background-color: var(--scala-grigi-gray-3);
      }
    }

    .tva-arrow {
      position: absolute;
      top: 50%;

      &.tva-arrow-sx {
        left: 0;
        transform: translate(-50%, -50%) rotate(90deg);
        margin-right: 0.3rem;

        &.graph {
          margin-right: toRem(12);
        }
      }
      &.tva-arrow-dx {
        // right: calc(var(--page-padding-h) * -1);
        transform: translate(-50%, -50%) rotate(-90deg);
      }
    }
  }
}
</style>

<style lang="scss">
/*! Flickity v2.2.0
https://flickity.metafizzy.co
---------------------------------------------- */

.flickity-enabled {
  position: relative;
}

.flickity-enabled:focus {
  outline: none;
}

.flickity-viewport {
  overflow: hidden;
  position: relative;
  height: 100%;
  overflow: visible;
}

.flickity-slider {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* draggable */

.flickity-enabled.is-draggable {
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.flickity-enabled.is-draggable .flickity-viewport {
  cursor: move;
  cursor: -webkit-grab;
  cursor: grab;
}

.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
</style>
